<script>
export default {
  name: 'VueProgressButton',
  props: {
    fillColor: {
      type: String,
      default: '#555',
    },
    duration: {
      type: Number,
      default: 2000,
    },
    height: {
      type: Number,
      default: 100,
    },
    position: {
      type: String,
      default: 'fill',
    },
    progress: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  computed: {
    styling() {
      const styling = {
        width: this.progress + '%',
        'background-color': this.fillColor,
      };
      switch (this.position) {
        case 'top':
          styling.height = this.height + 'px';
          styling.top = 0;
          break;
        case 'bottom':
          styling.height = this.height + 'px';
          styling.bottom = 0;
          break;
        default:
          styling.top = 0;
          styling.bottom = 0;
      }
      return styling;
    },
  },
  methods: {
    click(event) {
      this.$emit('click', event);
    },
  },
};
</script>

<template>
  <button
    :class="{ active: true }"
    class="__progress-button"
    data-progress-style="fill-back"
    @click="click"
  >
    <div :style="styling" class="__progress" />
    <div class="__progress-button-content"><slot /></div>
  </button>
</template>

<style lang="scss" scoped>
.__progress {
  border-radius: 2rem;
  &:hover {
    background-color: darken(#4059e1, 10);
  }
}

.__progress-button {
  background: white;
  border: unset;
  border-radius: 5rem;
  color: black;
  font-size: 1.4rem;
  font-weight: 800;
  margin-left: 2rem;
  outline: none;
  padding: 1.1rem 2.4rem;
  position: relative;
  &:hover {
    background-color: darken(white, 10);
  }
}
.__progress-button:not(.active) {
  cursor: pointer;
}
.__progress-button .__progress-button-content {
  opacity: 1;
  position: relative;
  z-index: 1;
}
.__progress-button .__progress {
  left: 0;
  opacity: 0;
  position: absolute;
  right: 0;
  transition: all 0s ease;
  width: 0;
  z-index: 1;
}
.__progress-button.active .__progress {
  opacity: 1;
  transition-timing-function: ease;
}
</style>
